import LanguageIcon from "./earth-svgrepo-com.svg";
import GeoIcon from "./geo-alt-svgrepo-com.svg";
import LocationIcon from "./distance-svgrepo-com.svg";
import EuroIcon from "./euro-sign-svgrepo-com.svg";
import CoupleIcon from "./Layer_1.svg";
import QualificationIcon from "./qualification-icon.svg";

export {
	LanguageIcon,
	GeoIcon,
	LocationIcon,
	EuroIcon,
	CoupleIcon,
	QualificationIcon
}

export const cardImages = [LanguageIcon, GeoIcon, LocationIcon, EuroIcon, CoupleIcon, QualificationIcon];

